import { GridPaginationModel } from '@mui/x-data-grid';
import { useState } from 'react';

export const DEFAULT_PAGE_SIZE = 100;

const useTable = (defaultPageSize?: number) => {
  const [page, setPage] = useState(1);

  const [pageSize, setPageSize] = useState(defaultPageSize || DEFAULT_PAGE_SIZE);

  const [totalItems, setTotalItems] = useState(0);

  const persistTotalItems = (responseTotal: number) => {
    if (responseTotal) {
      setTotalItems(responseTotal);
    }
  };

  const onPageChange = ({ page, pageSize }: GridPaginationModel) => {
    setPage(page + 1);
    setPageSize(pageSize);
  };

  return {
    page,
    pageSize,
    totalItems,
    onPageChange,
    persistTotalItems,
  };
};
export default useTable;
